import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React from 'react'
import GridDefaultActionButton, {
  GridDefaultActionButtonProps,
} from 'core/elements/grid/buttons/GridDefaultActionButton'
import Theme from 'core/themes/model'

const useStyles = makeStyles<Theme>((theme) => ({
  btn: {
    '& > .button-text > .button-icon': {
      color: theme.components.graph.error,
    },
    '& > .button-text': {
      color: theme.components.graph.error,
    },
    '&:hover > .button-text': {
      color: theme.components.graph.error,
    },
  },
}))

export default function GridDefaultDeleteButton<T>({
  children = 'Delete',
  onClick,
  className,
  ...rest
}: GridDefaultActionButtonProps<T>) {
  const classes = useStyles()
  return (
    <GridDefaultActionButton
      {...rest}
      icon="trash-alt"
      className={clsx(className, classes.btn)}
      onClick={onClick}
    >
      {children}
    </GridDefaultActionButton>
  )
}
